export function encodeTextAsBinary(text: string): Uint8Array {
    const encoder = new TextEncoder();
    return encoder.encode(text);
}

export function decodeTextFromBinary(binary: Uint8Array | ArrayBuffer): string {
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(binary);
}
